import React, { Component } from 'react'
import Keen from 'keen-js'
import { object, string } from 'prop-types'

// utils
import { createQuery, runQuery, createQueryCTA, createQueryGambi } from '../../../utils/KeenReport'

// components
import Spinner from '../../Spinner'
import CompleteFunnelGraph from '../CompleteFunnelGraph'

class CTADistributionFunnelWithClicks extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: true,
      hasError: false,
      recommends: 'Carregando...',
      plays: 'Carregando...',
      playrate: 'Carregando...'
    }

    this.runKeen = this.runKeen.bind(this)
    this.prepareDataToGraph = this.prepareDataToGraph.bind(this)
    this.toggleVideoPlay = this.toggleVideoPlay.bind(this)
  }
  componentDidMount () {
    this.runKeen(this.props)
  }
  componentWillReceiveProps (nextProps) {
    this.runKeen(nextProps)
  }
  toggleVideoPlay (hasVideoPlay) {
    this.setState({
      hasVideoPlay
    }, () => { this.prepareDataToGraph() })
  }
  prepareDataToGraph () {
    const { video, campaign } = this.props
    let { recommendations, plays, videoPlays, ctaGroup, hasVideoPlay, clicks } = this.state
    let dataForGraph = [
      { label: 'Cliques', value: clicks, type: 'line', rate: 1, color: '#3de2e5' },
      { label: 'Visitas', value: recommendations, type: 'line', rate: (recommendations / clicks), color: '#1F77B4' },
      { label: 'Plays', value: plays, type: 'line', rate: (plays / recommendations), color: '#FF7F0E' }
    ]

    let line = { label: 'Conversão', values: [], type: 'cta-group', color: '#2CA02C', total: 0, rate: 0 }
    ctaGroup.forEach((cta) => {
      if (video && video.hasOwnProperty('conversion_filter_group_by')) {
        line.values.push({
          label: cta[video.conversion_filter_group_by],
          value: cta.result
        })
      } else {
        line.values.push({
          label: cta[campaign.conversion_filter_group_by],
          value: cta.result
        })
      }
      line.total += cta.result
    })
    line.rate = line.total / plays

    if (hasVideoPlay) {
      dataForGraph.push({ label: 'Player tocar video', value: videoPlays, type: 'line', color: '#ad48a1', rate: (videoPlays / plays) })
      line.rate = line.total / videoPlays
    }

    dataForGraph.push(line)

    this.setState({
      isLoading: false,
      hasError: false,
      dataForGraph
    })
  }
  runKeen (props) {
    Keen.ready(() => {
      let { campaign, actor, timeframe, video, filters } = props
      let queries

      this.setState({
        isLoading: true,
        hasError: false
      })
      if (actor === 'pessoas') {
        queries = [
          createQuery('count_unique', 'video_recomended', timeframe, campaign, video, 'client_viewer_id', null, filters),
          createQuery('count_unique', 'video_unique_click', timeframe, campaign, video, 'client_viewer_id', null, filters),
          createQueryGambi('count_unique', 'video_unique_play', timeframe, campaign, video, 'client_viewer_id', null, filters)
        ]
        if (video && video.conversion_filter && video.conversion_filter_group_by) {
          queries.push(
            createQueryCTA('count_unique', 'user_interacted', timeframe, campaign, video, 'client_viewer_id', null, [...video.conversion_filter, ...filters], video.conversion_filter_group_by)
          )
        } else {
          queries.push(
            createQueryCTA('count_unique', 'user_interacted', timeframe, campaign, null, 'client_viewer_id', null, [...campaign.conversion_filter, ...filters], campaign.conversion_filter_group_by)
          )
        }
        queries.push(createQuery('count_unique', 'url_expanded', timeframe, null, video, 'viewer_id', null, filters))
      } else {
        queries = [
          createQuery('count', 'video_recomended', timeframe, campaign, video, null, null, filters),
          createQuery('count', 'video_unique_click', timeframe, campaign, video, null, null, filters),
          createQueryGambi('count', 'video_unique_play', timeframe, campaign, video, null, null, filters)
        ]
        if (video && video.conversion_filter && video.conversion_filter_group_by) {
          queries.push(
            createQueryCTA('count', 'user_interacted', timeframe, campaign, video, null, null, [...video.conversion_filter, ...filters], video.conversion_filter_group_by)
          )
        } else {
          queries.push(
            createQueryCTA('count', 'user_interacted', timeframe, campaign, null, null, null, [...campaign.conversion_filter, ...filters], campaign.conversion_filter_group_by)
          )
        }
        queries.push(createQuery('count', 'url_expanded', timeframe, null, video, null, null, filters))
      }
      runQuery(queries)
        .then((res) => {
          this.setState({
            recommendations: res[0].result,
            plays: res[1].result,
            videoPlays: res[2].result,
            ctaGroup: res[3].result,
            clicks: res[4].result
          }, () => { this.prepareDataToGraph() })
        }, (err) => {
          console.log('Erro rodando a query do Keen.', err)
          this.setState({
            hasError: true
          })
        })
    })
  }
  render () {
    let { isLoading, hasError } = this.state
    return (
      <div>
        <div className={isLoading ? 'hidden' : ''}>
          <CompleteFunnelGraph
            dataForGraph={this.state.dataForGraph}
            toggleVideoPlay={this.toggleVideoPlay}
          />
        </div>
        <Spinner isLoading={isLoading} hasError={hasError} runKeen={() => { this.runKeen(this.props) }} />
      </div>
    )
  }
}

CTADistributionFunnelWithClicks.propTypes = {
  timeframe: object,
  campaign: object,
  actor: string,
  video: object
}

export default CTADistributionFunnelWithClicks



// WEBPACK FOOTER //
// ./src/components/charts/Funnels/CTADistributionFunnelWithClicks.js